import { render, staticRenderFns } from "./anteprima.vue?vue&type=template&id=62ba8d59"
import script from "./anteprima.vue?vue&type=script&lang=js"
export * from "./anteprima.vue?vue&type=script&lang=js"
import style0 from "./anteprima.vue?vue&type=style&index=0&id=62ba8d59&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports